import { Quote } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

export const TestimonialsSection = () => {
  const { t } = useLanguage();

  const testimonials = [
    { quote: t('testimonials.q1'), role: t('testimonials.r1') },
    { quote: t('testimonials.q2'), role: t('testimonials.r2') },
    { quote: t('testimonials.q3'), role: t('testimonials.r3') },
  ];

  return (
    <section className="py-20 md:py-28 bg-white" data-testid="testimonials-section">
      <div className="container-0g">
        <div className="mb-12 md:mb-16">
          <p className="section-label">{t('testimonials.label')}</p>
          <h2 className="section-title mb-4">{t('testimonials.title')}</h2>
          <p className="text-lg text-slate-600 max-w-2xl">{t('testimonials.subtitle')}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((item, i) => (
            <figure
              key={i}
              className="bg-slate-50 border border-slate-200 rounded-sm p-8 flex flex-col hover:border-teal-500 transition-colors"
              data-testid={`testimonial-card-${i}`}
            >
              <Quote className="h-7 w-7 text-teal-600 mb-5" aria-hidden="true" />
              <blockquote className="text-slate-700 leading-relaxed flex-1 mb-6">
                “{item.quote}”
              </blockquote>
              <figcaption className="text-sm font-medium text-slate-500 border-t border-slate-200 pt-4">
                {item.role}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
